export const isMobile = function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

